import { initialSelectionState } from '../../core/components/annotations/providers/AnnotationsDataInitialState.js';
import { TRUNCATION_MODE } from '../../core/components/legend/range/constants.js';
import { defaultRatio } from '../../core/constants.js';
import { UndefinedContent, type XYChartState } from '../types/state.js';
import {
  XYChartAxisProps,
  XYChartChartLegendProps,
  XYChartConfigProperties,
  XYChartNumericalAxisProps,
  XYChartToolbarProps,
} from '../types/xy-chart.js';

export const DEFAULT_CHART_HEIGHT = 300;

export const DEFAULT_COLOR_PALETTE = 'blue';

export const DEFAULT_LOADING_STATE = false;

type XYChartAxisDefaults = Pick<XYChartAxisProps, 'hidden' | 'reversed'> &
  Pick<XYChartNumericalAxisProps, 'min' | 'max'>;

export const DEFAULT_AXIS_CONFIG: XYChartAxisDefaults = {
  hidden: false,
  min: 'auto',
  max: 'auto',
  reversed: false,
};

export const DEFAULT_LEGEND_RANGE_FORMATTER = {
  maximumFractionDigits: 1,
};

export const initialState: XYChartState = {
  zoom: {
    zoomInEnabled: true,
    zoomOutEnabled: false,
  },
  currentDomain: undefined,
  select: undefined,
  interactionMode: 'explore',
  explore: {
    visible: false,
    pinned: false,
    position: undefined,
    content: UndefinedContent,
  },
  toolbar: {
    visible: false,
  },
  thresholds: { hoveredThresholdId: undefined },
  highlightedSeriesIds: [],
  annotations: initialSelectionState,
};

export const defaultLegend: XYChartChartLegendProps = {
  hidden: false,
  position: 'auto',
  ratio: defaultRatio,
} as const;

export const defaultToolbar: XYChartToolbarProps = {
  hidden: false,
  placement: 'top-right',
  collapsed: false,
  draggable: true,
} as const;

export const defaultConfig: XYChartConfigProperties = {
  legend: defaultLegend,
  toolbar: defaultToolbar,
  colorPalette: DEFAULT_COLOR_PALETTE,
  truncationMode: TRUNCATION_MODE.Middle,
  thresholds: [],
  yAxes: [],
  xAxes: [],
};

export const XY_CHART_ARIA_LABEL = 'XY Chart';
/** Annotations bottom padding in pixels */
export const ANNOTATIONS_PADDING_BOTTOM = 6;
